import gql from 'graphql-tag';
import { useQuery } from '@apollo/client';
import { InvalidZipCodeError } from 'utils/errors/client-errors';

export const useEgridSubregion = zipCode => {
  const {
    data: validationData,
    loading: validationLoading,
    error: validationError,
  } = useQuery<GetZipCodeValidationQuery, GetZipCodeValidationQueryVariables>(
    GET_ZIP_CODE_VALIDATION,
    {
      variables: { zipCode },
    }
  );

  const isInvalidZipCode =
    validationData && !validationData?.validation?.zipCode.isValid;
  const invalidZipCodeError = isInvalidZipCode
    ? new InvalidZipCodeError()
    : undefined;

  const skip = isInvalidZipCode || validationLoading || !!validationError;
  const { data, loading, error } = useQuery<
    GetEgridSubregionQuery,
    GetEgridSubregionQueryVariables
  >(GET_EGRID_SUBREGION, {
    skip,
    variables: { zipCode },
  });

  return {
    data,
    error: invalidZipCodeError || error || validationError,
    loading: loading || validationLoading,
  };
};

export const GET_EGRID_SUBREGION = gql`
  query GetEgridSubregion($zipCode: String!) {
    zipCode(zip: $zipCode) {
      id
      egridSubregion {
        id
        energySummary {
          fossilFuels
          renewables
          nuclear
        }
        energyBreakdown {
          wind
          solar
          hydro
          geothermal
          biomass
          nuclear
          otherFossil
          oil
          gas
          coal
        }
      }
    }
  }
`;

export const GET_ZIP_CODE_VALIDATION = gql`
  query GetZipCodeValidation($zipCode: String!) {
    validation {
      zipCode(zipCode: $zipCode) {
        isValid
      }
    }
  }
`;

export const getEgridSubregionMock = {
  zipCode: {
    egridSubregion: {
      energyBreakdown: {
        biomass: 0.1,
        coal: 0.1,
        gas: 0.1,
        geothermal: 0.1,
        hydro: 0.1,
        nuclear: 0.1,
        oil: 0.1,
        otherFossil: 0.1,
        solar: 0.1,
        wind: 0.1,
      },
      energySummary: {
        fossilFuels: 0.5,
        nuclear: 0.2,
        renewables: 0.3,
      },
      id: 2,
    },
    id: 1,
  },
};

export const getZipCodeValidationMock = {
  validation: {
    zipCode: {
      isValid: true,
    },
  },
};

export const useEgridSubregionMock = {
  data: getEgridSubregionMock,
  error: undefined,
  loading: false,
};
